module.exports = __webpack_public_path__ + "static/img/t4-1.b8d06db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t4-1.png
// module id = LTxm
// module chunks = 1